var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asset-tags" }, [
    _vm.hasFeeExempt
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--fee" },
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass:
                                    "asset-tags__chip asset-tags__chip--line-through",
                                  attrs: { color: "success", "x-small": "" }
                                },
                                [_vm._v(" fee ")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  407290934
                )
              },
              [_c("span", [_vm._v(" Isento no cálculo de Fee ")])]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasTaxExempt
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--tax" },
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "asset-tags__chip",
                                  attrs: { color: "primary", "x-small": "" }
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v(" mdi-currency-usd-off ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1485211879
                )
              },
              [_c("span", [_vm._v(" Ativo isento de IR ")])]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasIlliquid
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--illiquid" },
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "asset-tags__chip",
                                  attrs: { "x-small": "", color: "white" }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "info" } },
                                    [_vm._v("mdi-domain")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2943387779
                )
              },
              [_c("span", [_vm._v(" Ativo ilíquido ")])]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasDesconsiderarRentabilidade
      ? _c(
          "div",
          {
            staticClass:
              "asset-tags__item asset-tags__item--desconsiderar-rentabilidade"
          },
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass:
                                    "asset-tags__chip asset-tags__chip--line-through",
                                  attrs: { color: "warning", "x-small": "" }
                                },
                                [_vm._v(" % ")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3078522972
                )
              },
              [
                _c("span", [
                  _vm._v(" Desconsiderado na rentabilidade da carteira ")
                ])
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasMarketMarking
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--mm" },
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "asset-tags__chip",
                                  attrs: { color: "info", "x-small": "" }
                                },
                                [_vm._v("MM")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3081221131
                )
              },
              [_c("span", [_vm._v(" Marcação a mercado ")])]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasAlertUpdate
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--update" },
          [
            _c("AlertUpdateAsset", {
              attrs: { date: _vm.asset._d_referencia_pl, noSpacing: "" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.hasComposicao
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--composition" },
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "asset-tags__icon-button",
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleOpenDetalhes({
                                        action: "composicao"
                                      })
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "primary" } },
                                    [_vm._v(" mdi-chart-pie ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3982745632
                )
              },
              [
                _c("span", [
                  _vm._v(" Este ativo possui uma composição. "),
                  _c("br"),
                  _vm._v(" Clique ou abra o menu "),
                  _c("b", [_vm._v("Ver detalhes")]),
                  _vm._v(" para visualizar. ")
                ])
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasWarnings
      ? _c(
          "div",
          { staticClass: "asset-tags__item asset-tags__item--warning" },
          [
            _c(
              "v-tooltip",
              {
                attrs: { right: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "asset-tags__icon-button",
                                  attrs: {
                                    small: "",
                                    icon: "",
                                    disabled: _vm.readonly
                                  },
                                  on: { click: _vm.handleOpenNewAsset }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "warning" } },
                                    [_vm._v(" mdi-alert-circle-outline ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1911396416
                )
              },
              [
                _c("span", { staticClass: "asset-tags__warning-text" }, [
                  _vm._v(" " + _vm._s(_vm.warningText || "Com alertas") + " ")
                ])
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.hasTags
      ? _c(
          "div",
          {
            staticClass:
              "asset-tags__item asset-tags__item--tags asset-tags__list"
          },
          [
            _c("TagChips", {
              attrs: {
                tags: _vm.tagsTextList,
                "can-edit": false,
                colorMode: "fixed",
                "use-small-chips": ""
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }